<div class="bg-white p-3 m-2">
  <div class="d-flex justify-content-between align-items-center">
    <div *ngIf="!showForm">
      <h2 class="m-0">E-Content - Courses</h2>
    </div>
    <button
      mat-raised-button
      color="primary"
      (click)="createEcontentData()"
      *ngIf="!showForm"
    >
      <mat-icon>cloud_upload</mat-icon>
      Add eContent Page
    </button>
  </div>

  <!-- Content Section -->
  <div class="mt-2 h-100" *ngIf="!showForm">
    <!-- Table Section -->
    <table
      *ngIf="
        dataSource && dataSource.data && dataSource.data.length > 0;
        else emptyState
      "
      mat-table
      [dataSource]="dataSource"
      class="mat-elevation-z1"
    >
      <!-- Course Name Column -->
      <ng-container matColumnDef="courses">
        <th mat-header-cell *matHeaderCellDef>Courses</th>
        <td mat-cell *matCellDef="let element">{{ element.course_name }}</td>
      </ng-container>

      <!-- Last Update Column -->
      <ng-container matColumnDef="last_update">
        <th mat-header-cell *matHeaderCellDef>Last Update</th>
        <td mat-cell *matCellDef="let element">
          {{ element.updated_at | date : "dd/MM/yyyy" }}
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              (click)="viewESemisterData(element.course_id)"
            >
              <mat-icon>visibility</mat-icon>
              <span>View</span>
            </button>
            <button mat-menu-item>
              <mat-icon>edit</mat-icon>
              <span>Edit</span>
            </button>
            <button
              mat-menu-item
              (click)="deleteEContentCoursesData(element.course_id)"
            >
              <mat-icon>delete</mat-icon>
              <span>Delete</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <!-- Header and Row Definitions -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <!-- Empty State Template -->
    <ng-template #emptyState>
      <mat-card class="empty-state-card text-center py-5">
        <mat-card-content>
          <mat-icon class="empty-icon" style="font-size: 48px; color: #ccc">
            folder_off
          </mat-icon>
          <h2>No Data Available</h2>
          <p>Please add E-content courses to get started.</p>
          <button
            mat-raised-button
            color="primary"
            (click)="createEcontentData()"
          >
            <mat-icon>add</mat-icon>
            Create New Course
          </button>
        </mat-card-content>
      </mat-card>
    </ng-template>
  </div>

  <!-- Form Section -->
  <app-e-content-form
    *ngIf="showForm"
    [questions]="questions"
    [form]="form"
    (submitForm)="onFormSubmit($event)"
    (cancel)="onFormCancel()"
  ></app-e-content-form>
</div>
